export function Card({ children, className }) {
    return <div className={`rounded-lg p-2 ${className}`}>{children}</div>;
  }
  

  export function CardContent({ children }) {
    return <div className="p-2">{children}</div>;
  }
  